import Vue from 'vue'
import { xjp_oos_domain, paymentInStoreImageArr } from "../../utils/common";

import {
  SET_GOODS_LIST,
  SET_PROMOTION,
  SET_PROMOTION_GOODS_LIST,
  SET_DELIVERY_TYPE,
  SET_ADDRESS,
  SET_PICKUP,
  SET_ACTIVE,
  SET_PAY_TYPE,
  SET_TRANSACTION_CODE,
  SET_FREIGHT,
  SET_ORDER_NO
} from '../mutation-types'
import api from '@/api'
import { Message } from 'element-ui';
const state = {
  active: 0,
  goodsList: [],
  promotion: {},
  promotionGoodsList: [],
  deliveryType: '',
  freight: NaN,
  address: {
    addressId: '',
    addressee: '',
    phone: '',
    country: "Australia",
    city: [],
    cityName: [],
    addressDetails: ''
  },
  pickup: {
    pickupShopId: '',
    pickupShoName: '',
    pickupTime: '',
  },
  payType: {
    payName: "RoyalPayCard",
    payCode: "RoyalPayCard",
    payType: "5",
    img: xjp_oos_domain + "/pc-en/img/pay_royal_card.jpg",
    check: true
  },
  transactionCode: '',
  orderNo: ''

}
const mutations = {
  [SET_GOODS_LIST](state, goodsList) {
    Vue.set(state, 'goodsList', goodsList)
  },
  [SET_PROMOTION](state, promotion) {
    Vue.set(state, 'promotion', promotion)
  },
  [SET_PROMOTION_GOODS_LIST](state, promotionGoodsList) {
    Vue.set(state, 'promotionGoodsList', promotionGoodsList)
  },
  [SET_DELIVERY_TYPE](state, deliveryType) {
    Vue.set(state, 'deliveryType', deliveryType)
  },
  [SET_PICKUP](state, pickup) {
    Vue.set(state, 'pickup', pickup)
  },
  [SET_ADDRESS](state, address) {
    Vue.set(state, 'address', address)
  },
  [SET_ACTIVE](state, active) {
    Vue.set(state, 'active', active)
  },
  [SET_PAY_TYPE](state, payType) {
    Vue.set(state, 'payType', payType)
  },
  [SET_TRANSACTION_CODE](state, transactionCode) {
    Vue.set(state, 'transactionCode', transactionCode)
  },
  [SET_FREIGHT](state, freight) {
    Vue.set(state, 'freight', freight)
  },
  [SET_ORDER_NO](state, orderNo) {
    Vue.set(state, 'orderNo', orderNo)
  }

}
const actions = {
  /**
   * 初始化订单信息
   * @param {*} param0
   * @param {*} params
   */
  initOrderParams: ({ commit }, params) => {
    // console.log(params)
    let { goodsList, promotion, promotionGoodsList } = params
    commit(SET_GOODS_LIST, goodsList)
    commit(SET_PROMOTION, promotion)
    commit(SET_PROMOTION_GOODS_LIST, promotionGoodsList)
  },
  /**
   * 重置订单信息
   */
  cleanOrderParams: (({ commit }) => {
    commit(SET_GOODS_LIST, [])
    commit(SET_PROMOTION, {})
    commit(SET_PROMOTION_GOODS_LIST, [])
    commit(SET_DELIVERY_TYPE, '')
    commit(SET_PICKUP, {
      pickupShopId: '',
      pickupShoName: '',
      pickupTime: '',
    })
    commit(SET_ADDRESS, {
      addressId: '',
      name: '',
      phone: '',
      city: [],
      cityName: [],
      addressDetails: ''
    })
    commit(SET_ACTIVE, 0)
    commit(SET_PAY_TYPE, {})
    commit(SET_TRANSACTION_CODE, '')
    commit(SET_FREIGHT, 0)
    commit(SET_ORDER_NO, "")
  }),
  /**
   * 设置支付方式
   */
  setPayType: (({ commit }, payType) => {
    commit(SET_PAY_TYPE, payType)
  }),
  /**
   * 全局只有在订单页面注册可调用
   */
  setAddressId: (({ commit, state }, addressId) => {
    state.address.addressId = addressId
    commit(SET_ADDRESS, state.address)
  }),
  /**
   * 计算运费
   * @param {address,orderGoods,shippingType} param0
   */
  computedFreight: (({ commit, state, rootGetters }, params) => {
    // console.log(params)
    return new Promise((resolve, reject) => {
      let { address, orderGoods, shippingType } = params
      address = _.isEmpty(address) ? (state.address.cityName || []).join('-') : address
      orderGoods = _.isEmpty(orderGoods) ? state.goodsList.concat(state.promotionGoodsList) : orderGoods
      shippingType = _.isEmpty(shippingType) ? rootGetters.getShippType() : shippingType
      // console.log(shippingType, rootGetters.getShippType())
      address || Message({
        message: 'Freight acquisition failed: Address is Empty',
        type: 'error'
      })
      if (!orderGoods.length) {
        Message({
          message: 'Freight acquisition failed: No item selected is Empty',
          type: 'error'
        })
        return
      }
      api.order.freight({ address, orderGoods, shippingType })
        .then(res => {
          let { result: { freight } } = res
          commit(SET_FREIGHT, freight)
          resolve(freight)
        })
        .catch(err => {
          Message({
            message: 'Freight acquisition failed',
            type: 'error'
          })
          commit(SET_FREIGHT, 0)
          commit(SET_ADDRESS, {
            addressId: '',
            name: '',
            phone: '',
            city: [],
            cityName: [],
            addressDetails: ''
          })
          reject(err)
        })
    })
  }),

  /**
   * 获取交易码
   */
  getTradeCode: (({ commit }) => {
    return new Promise((resolve, reject) => {
      api.order.getTradeCode()
        .then(res => {
          let { result: { transactionCode } } = res;
          commit(SET_TRANSACTION_CODE, transactionCode)
          resolve(transactionCode)
        })
        .catch(err => reject(err))
    })

  }),
  /**
   * 创建订单
   */
  createOrder: (({ state, dispatch, rootGetters }) => {
    return new Promise((resolve, reject) => {
      let { addressId: deliveryAddressId } = state.address
      let transactionCode = state.transactionCode
      let actionGoods = state.promotionGoodsList
      let promotion = state.promotion
      actionGoods.forEach(e => e.actionTypeId = promotion.goodsActionTypeId)
      let orderGoods = state.goodsList
      let createOrderParams = {
        transactionCode,
        orderGoods,
        actionGoods,
      }
      createOrderParams.shippingType = rootGetters.getShippType();
      switch (createOrderParams.shippingType) {
        case "2":
          createOrderParams.deliveryAddressId = deliveryAddressId
          break;
        case "3":
          createOrderParams.shopId = state.pickup.pickupShopId;
          createOrderParams.terminalDateTime = state.pickup.pickupTime;
          break;
        case "":
      }
      if (!createOrderParams.shippingType) {
        reject({ message: 'delivery Type Error' })

      }
      api.order.createOrder(createOrderParams)
        .then(res => {
          let { result } = res
          dispatch("cart/initShoppingCart", null, { root: true });
          resolve(result)
        })
        .catch(err => reject(err))
    })
  }),
  /**
   * 支付
   * @param {*} param0
   * @param {orderNo,payType} orderPayParams
   * @returns
   */
  payOrder: ({ state }, payParams) => {
    let { orderNo } = payParams
    // console.log(state.payType)
    let payType = state.payType.payType
    let params = {
      orderNo,
      payType
    }
    return new Promise((resolve, reject) => {
      api.order.payOrder(params)
        .then(res => {
          let { result: { jumpUrl } } = res
          resolve(jumpUrl)
        })
        .catch(err => reject(err))
    })
  },
  specialPay({ state }, params) {
    let { orderNo, imgUrl, payPassword } = params;
    let payType = state.payType.payType

    return new Promise((resolve, reject) => {
      if (["transfer", "cashOnDelivery"].includes(payType)) {
        //转账 到付
        imgUrl = "transfer" === payType ? imgUrl : paymentInStoreImageArr[0]
        api.order
          .savePayCertificates({ imgUrl, orderNo })
          .then(
            res => {
              let { result } = res;
              if (result === 1) {
                Message({
                  type: "success",
                  message:
                    "Upload successful pending approval，Due to the transfer mechanism, it takes 1 day to confirm the receipt of the transfer information  "
                });
              }
              resolve(result)
            }
          ).catch(
            err =>
              reject(err)
          )
      } else if (payType === "0") {
        //支付密码支付
        api.order
          .payOrder({
            payType,
            orderNo,
            password: payPassword
          })
          .then(res => { }).catch(err => reject(err));
      }

    })
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js